import { trackButtonClick } from "./trackButtonClick";

const handleVideographerSignUpButtonClick = (userInfo, buttonName) => {
            
            //mixpanel buttonClick tracking
            trackButtonClick(buttonName, userInfo, "Videographer Sign Up", "Primary");
            window.open(`https://docs.google.com/forms/d/e/1FAIpQLSfmbQMIdvZxM0HBrt79qkHcL477sOOn4pVJMvGP_bLSxanuNQ/viewform?usp=pp_url&entry.1082115788=${userInfo?.firstName ? userInfo.firstName + '+' : ''}${userInfo?.lastName ? userInfo.lastName : ''}&entry.1565305639=${userInfo?.email ? userInfo.email : ''}&entry.1868722683=${userInfo?.company ? userInfo.company : ''}`,'_blank')
          };

export default handleVideographerSignUpButtonClick;